
// import React, { useState } from "react";
import React, { useEffect, useState, useCallback } from "react";
import notificationService from "services/notification.service";
import cn from "classnames";
import styles from "./Site.module.scss";
import StatusComponent from "../../components/StatusComponent";
import { Link } from "react-router-dom";
import {
  getRequestInAssets as getRequestAssets,
  postRequestInAssets as postRequestAssets,
  putRequestInAssets as putRequestAssets,
} from "services/axiosAssetsBaseClient";

import { getRequest, postRequest } from "services/axiosBaseClient";
import { dataTool } from "echarts";

var id = undefined;
var action = null;
var title = "Site Information";
var view = undefined;
var onlyView = false;
var readOnlyField = true;

export default function SiteView(props) {
  const [energyUsedCount, setEnergyUsedCount] = useState("");
  const [assetsCount, setAssetsCount] = useState("");
  const [temperatureCount, setTemperatureCount] = useState("");
  const [energyCount, setenergyCount] = useState("");
  const [siteDetail, setSiteDetail] = useState("");

  const initialFormValues = {
    siteName: "",
    driverName: "",
    siteAddress1: "",
    siteAddress2: "",
    countryId: "",
    stateId: "",
    city: "",
    pincode: "",
    latitude: "",
    logtitude: "",

    siteStatus: "",
    numberOfswapStation: "",
  };
  // console.log(siteDetail)
  const patchForm = (data) => {
    // console.log("data", data)
    setFormValues({
      ...formValues,
      siteName: data?.name,
      driverName: data?.contactPersonName,
      id: data?.id,
      siteAddress1: data?.address1,
      siteAddress2: data?.address2,
      countryId: data?.country,
      pincode: data?.pinCode,
      city: data?.city,
      logtitude: data?.logitude,
      latitude: data?.latitude,
      stateId: data?.state,
      siteStatus: data?.status,
      numberOfswapStation: data?.numberOfSwapStations,
    });
  };

  // const siteBiIdData = {
  //   id: 1,
  //   name: siteDetail?.name,
  //   zoneId: siteDetail?.zoneId,
  //   logitude: siteDetail?.logitude,
  //   latitude: siteDetail.latitude,
  //   numberOfSwapStations: siteDetail.numberOfSwapStations,
  //   status: siteDetail.status,
  //   commissionedOn: siteDetail.commissionedOn,
  //   createdAt: "",
  //   contactPersonName: siteDetail.contactPersonName,
  //   address1: siteDetail.address1,
  //   address2: siteDetail.address2,
  //   state: siteDetail.state,
  //   city: siteDetail.city,
  //   pinCode: siteDetail.pinCode,
  //   enterprise: siteDetail.enterprise,
  // };

  const arrayData = [
    {
      ic_background: "#FCC644",
      ic: require("assets/energyUsedIcon.svg").default,
      // ic: require("assets/charger-status.png").default,
      title: "Energy Used",
      progres1color: "#00792C",
      progres2color: "#23297A",
      progres3color: "#4A81D4",
      progress1name: "Energy",
      progress2name: "Daily Average",
      progress3name: "Today's",
      progress1percent: energyUsedCount.totalEnergy,
      progress2percent: energyUsedCount.dailyAverage,
      progress3percent: energyUsedCount.todayEnergy,
    },
    {
      ic_background: "#4A81D4",

      ic: require("assets/asset.svg").default,
      title: "Assets",
      progress1name: "Sites",
      progress2name: "Swap Stations",
      progress3name: "Batteries",

      progres1color: "#00792C",
      progres2color: "#FCC644",
      progres3color: "#4A81D4",

      progress1percent: assetsCount.TotalSite,
      progress2percent: assetsCount.TotalCharger,
      progress3percent: assetsCount.TotalBattery,
    },
    {
      ic_background: "#DE6421",
      ic: require("assets/tempIcon.svg").default,
      title: "Temperature",
      progress1name: "Average",
      progress2name: "High Temperature",
      progress3name: "Low Temperature",

      progres1color: "#DE6421",
      progres2color: "#E3324C",
      progres3color: "#8E54E9",

      progress1percent: temperatureCount.average,
      progress2percent: temperatureCount.highTemperature,
      progress3percent: temperatureCount.lowTemperature,
    },
    {
      ic_background: "#11CA6D",
      ic: require("assets/energyIcom.svg").default,
      title: "Energy",
      progress1name: "Total Energy",
      progress2name: "Consume Energy",
      progress3name: "Charging",

      progres1color: "#00792C",
      progres2color: "#8E54E9",
      progres3color: "#FCC644",

      progress1percent: energyCount?.totalEnergy? energyCount?.totalEnergy : 0,
      progress2percent: energyCount?.consumedEnergy? energyCount?.consumedEnergy : 0,
      progress3percent: energyCount?.charging? energyCount?.charging : 0,
    },
  ];

  // id = props.match.params.id;
  const [sitesList, setSitesList] = useState([]);

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");

  const getEneryUsedGraphCount = useCallback(async () => {
    await getRequest("bss/aggregation/totalEnergy?siteId=" + props.siteId)
      .then((res) => {
        if (res && res?.data) {
          setEnergyUsedCount(res.data);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  const getAssetsGraphCount = useCallback(async () => {
    await getRequest("bss/getTotalAssests?siteId=" + props.siteId)
      .then((res) => {
        setAssetsCount(res.data);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  const getTemperaturGraphCount = useCallback(async () => {
    await getRequest("bss/getTempDetails?siteId=" + props.siteId)
      .then((res) => {
        setTemperatureCount(res.data);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  const getEnergyCount = useCallback(async () => {
    await getRequest("bss/getEnergyDetails?siteId=" + props.siteId)
      .then((res) => {
        setenergyCount(res.data);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  const getSiteDetails = useCallback(async () => {
    // patchForm(siteBiIdData);
    await getRequestAssets(
      "bss/site/SiteInformation?siteId=" +
        props.siteId +
        "&enterprise=" +
        props.enterprise
    )
      .then((res) => {
        setSiteDetail(res.data);
        patchForm(res.data);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  useEffect(() => {
    getEneryUsedGraphCount();
    getAssetsGraphCount();
    getTemperaturGraphCount();
    getEnergyCount();
    getSiteDetails();
  }, []);

  console.log(siteDetail, "<---SITE DETAILS--->");

  const handleSubmit = (e) => {
    e.preventDefault();

    let result = validate(formValues);

    if (Object.values(result).every((x) => x === "")) {
      const obj = {
        sitData: {
          id: formValues?.id,
          name: formValues.siteName,
          logitude: formValues.logtitude,
          latitude: formValues.latitude,
          numberOfSwapStations: formValues.numberOfswapStation,
          status: formValues.siteStatus,
          contactPersonName: formValues.driverName,
          address1: formValues.siteAddress1,
          address2: formValues.siteAddress2,
          state: formValues.stateId,
          city: formValues.city,
          pinCode: formValues.pincode,
        },
        siteId: formValues.siteId,
      };

      if (action === "Update") {
        try {
          putRequestAssets("zone/updateZone", obj).then((res) => {
            if (res && res?.data) {
            }
          }).catch((error) => {
            notificationService.showNonBlacklistedError(
              error?.config?.url,
              error?.response?.data?.message
            );
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          postRequestAssets("zone/addZone", obj).then((res) => {
            if (res && res?.data) {
              // history.push("/Assets");
            }
          }).catch((error) => {
            notificationService.showNonBlacklistedError(
              error?.config?.url,
              error?.response?.data?.message
            );
          });
        } catch (error) {
          reset();
          console.log(error);
        }
      }
    }

    console.log(`form values -----> ${JSON.stringify(formValues)} `);
    console.log(`form errors -----> ${JSON.stringify(formErrors)} `);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  const validate = (formValues) => {
    const errors = {};

    if (!formValues.siteName) {
      errors.siteName = "Site Name is required!";
    } else {
      errors.zone = "";
    }
    if (!formValues.driverName) {
      errors.driverName = "Contact person name is required!";
    } else {
      errors.driverName = "";
    }

    if (!formValues.countryId) {
      errors.countryId = "Country name is required!";
    } else {
      errors.countryId = "";
    }

    if (!formValues.stateId) {
      errors.stateId = "State name is required!";
    } else {
      errors.stateId = "";
    }

    if (!formValues.siteAddress1) {
      errors.siteAddress1 = "Site addres line1 is required!";
    } else {
      errors.siteAddress1 = "";
    }
    if (!formValues.siteAddress2) {
      errors.siteAddress2 = "Site addres line2 is required!";
    } else {
      errors.siteAddress2 = "";
    }

    if (!formValues.latitude) {
      errors.latitude = "Latitude is required!";
    } else {
      errors.latitude = "";
    }

    if (!formValues.logtitude) {
      errors.logtitude = "Logtitude is required!";
    } else {
      errors.logtitude = "";
    }

    if (!formValues.siteStatus) {
      errors.siteStatus = "Site status is required!";
    } else {
      errors.siteStatus = "";
    }
    if (!formValues.numberOfswapStation) {
      errors.numberOfswapStation = "Number of swape station is required!";
    } else {
      errors.numberOfswapStation = "";
    }

    if (!formValues.pincode) {
      errors.pincode = "Pin code is required!";
    } else {
      errors.pincode = "";
    }
    if (!formValues.city) {
      errors.city = "City is required!";
    } else {
      errors.city = "";
    }

    setFormErrors(errors);
    return errors;
  };

  const reset = () => {
    setFormValues(initialFormValues);
  };

  return (
    <>
      {}

      <div className={cn(styles.body_flex_item4, styles.md)}>
        <div className={cn(styles.status_flex, styles.status_flex_layout)}>
          <div className={cn(styles.block46_item)}>
            <div
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <StatusComponent
                ic_background={arrayData[0].ic_background}
                ic={arrayData[0].ic}
                progress1name={arrayData[0].progress1name}
                progress2name={arrayData[0].progress2name}
                progress3name={arrayData[0].progress3name}
                progress1color={arrayData[0].progres1color}
                progress2color={arrayData[0].progres2color}
                progress3color={arrayData[0].progres3color}
                progress1percent={arrayData[0].progress1percent}
                progress2percent={arrayData[0].progress2percent}
                progress3percent={arrayData[0].progress3percent}
                header={arrayData[0].title}
              />
            </div>
          </div>
          <div className={cn(styles.block46_spacer)} />
          {/* <div className={cn(styles.flex4_spacer1)} /> */}
          <div className={cn(styles.block46_item)}>
            <div
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <StatusComponent
                ic_background={arrayData[1].ic_background}
                ic={arrayData[1].ic}
                progress1name={arrayData[1].progress1name}
                progress2name={arrayData[1].progress2name}
                progress3name={arrayData[1].progress3name}
                progress1color={arrayData[1].progres1color}
                progress2color={arrayData[1].progres2color}
                progress3color={arrayData[1].progres3color}
                progress1percent={arrayData[1].progress1percent}
                progress2percent={arrayData[1].progress2percent}
                progress3percent={arrayData[1].progress3percent}
                header={arrayData[1].title}
              />
            </div>
          </div>
          <div className={cn(styles.block46_spacer)} />
          <div className={cn(styles.block46_item)}>
            <div
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <StatusComponent
                ic_background={arrayData[2].ic_background}
                ic={arrayData[2].ic}
                progress1name={arrayData[2].progress1name}
                progress2name={arrayData[2].progress2name}
                progress3name={arrayData[2].progress3name}
                progress1color={arrayData[2].progres1color}
                progress2color={arrayData[3].progres2color}
                progress3color={arrayData[3].progres3color}
                progress1percent={arrayData[2].progress1percent}
                progress2percent={arrayData[2].progress2percent}
                progress3percent={arrayData[2].progress3percent}
                header={arrayData[2].title}
              />
            </div>
          </div>
          <div className={cn(styles.block46_spacer)} />

          <div className={cn(styles.block46_item)}>
            <div
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <StatusComponent
                ic_background={arrayData[3].ic_background}
                ic={arrayData[3].ic}
                progress1name={arrayData[3].progress1name}
                progress2name={arrayData[3].progress2name}
                progress3name={arrayData[3].progress3name}
                progress1percent={arrayData[3].progress1percent}
                progress2percent={arrayData[3].progress2percent}
                progress3percent={arrayData[3].progress3percent}
                progress1color={arrayData[3].progres1color}
                progress2color={arrayData[3].progres2color}
                progress3color={arrayData[3].progres3color}
                header={arrayData[3].title}
              />
            </div>
          </div>
        </div>
      </div>

      <hr className={cn(styles.line2, styles.line2_layout2)} />

      <div className={cn(styles.group, styles.group_layout, styles.mg20)}>
        <h2
          className={cn(
            styles.subtitle,
            styles.subtitle_layout,
            styles.pd10,
            styles.bd10,
            styles.Font_bold
          )}
        >
          {title}
        </h2>
        {/* <hr className={cn(styles.line2, styles.line2_layout)} /> */}

        <div
          className={cn(
            styles.group,
            styles.group_layout,
            styles.mg20,
            styles.pd10
          )}
        >
          <form>
            <div className={cn(styles.flex3, styles.flex3_layout)}>
              <div className={cn(styles.flex2, styles.flex2_layout)}>
                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"Site Name"}
                    </div>
                    <input
                      name="siteName"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.siteName}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.siteName}</p>
                </div>
                {/* {console.log(siteDetail, 'jfkdsjfladjlsfajdlfjldjf')} */}
                <div className={cn(styles.flex2_spacer)} />

                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"Contact Person Name"}
                    </div>
                    <input
                      name="driverName"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.driverName}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.driverName}</p>
                </div>
              </div>

              <div className={cn(styles.flex2, styles.flex2_layout)}>
                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"Site Address1"}
                    </div>
                    <input
                      name="siteAddress1"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.siteAddress1}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.siteAddress1}</p>
                </div>

                <div className={cn(styles.flex2_spacer)} />

                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"Site Address2"}
                    </div>
                    <input
                      name="siteAddress2"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.siteAddress2}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.siteAddress2}</p>
                </div>
              </div>

              <div className={cn(styles.flex2, styles.flex2_layout)}>
                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"Country"}
                    </div>

                    <input
                      name="countryId"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.countryId}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.countryId}</p>
                </div>

                <div className={cn(styles.flex2_spacer)} />

                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div className={cn(styles.line, styles.line_layout)}>
                      {"State"}
                    </div>

                    <input
                      name="stateId"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.stateId}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.stateId}</p>
                </div>
              </div>

              <div className={cn(styles.flex2, styles.flex2_layout)}>
                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"Latitude"}
                    </div>
                    <input
                      name="latitude"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.latitude}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.latitude}</p>
                </div>

                <div className={cn(styles.flex2_spacer)} />

                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"Longitude"}
                    </div>
                    <input
                      name="logtitude"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.logtitude}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.logtitude}</p>
                </div>
              </div>

              <div className={cn(styles.flex2, styles.flex2_layout)}>
                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"City"}
                    </div>
                    <input
                      name="city"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.city}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.city}</p>
                </div>

                <div className={cn(styles.flex2_spacer)} />

                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"Pin Code"}
                    </div>
                    <input
                      name="pincode"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.pincode}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.pincode}</p>
                </div>
              </div>

              <div className={cn(styles.flex2, styles.flex2_layout)}>
                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div className={cn(styles.line, styles.line_layout)}>
                      {"Site Status"}
                    </div>
                    <input
                      name="siteStatus"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.siteStatus}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.siteStatus}</p>
                </div>

                <div className={cn(styles.flex2_spacer)} />

                <div className={cn(styles.flex2_item)}>
                  <div className={cn(styles.block3, styles.block3_layout)}>
                    <div
                      className={cn(styles.text_body, styles.text_body_layout)}
                    >
                      {"Number of Swap Stations"}
                    </div>
                    <input
                      name="numberOfswapStation"
                      className={cn(styles.line2, styles.line2_layout)}
                      value={formValues.numberOfswapStation}
                      onChange={handleChange}
                      disabled={onlyView || readOnlyField}
                    />
                  </div>
                  <p>{formErrors.numberOfswapStation}</p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

// export default function Site(props) {
//   return (
//     <>
//       <Master opts={props} screen={SiteView} showStatus={true} />
//     </>
//   );
// }
